'use client';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxText from '@components/ParallaxText';
import CustomImage from '@components/CustomImage';
import cn from './style.module.scss';
export default function OgamiDestination(props: MarketingPageComponentProps) {
  const destinationSection = props?.locale?.section?.find(
    (section: any) => section.type === 'destination' && section.enabled
  );
  if (!destinationSection) return null;
  return (
    <Stack component="section" className={cn.ogamiDestinationWrapper}>
      <Box className={cn.ogamiDestinationInner}>
        <Box className={cn.ogamiDestinationStory}>
          <CustomImage
            src={destinationSection.ogamiDestinationTheme}
            alt={destinationSection.ogamiDestinationTheme}
            width={1200}
            height={800}
          />
        </Box>
        <Box className={cn.ogamiDestinationContent}>
          <Box className={cn.ogamiDestinationElement}>
            <Box className={cn.ogamiDestinationElement__heading}>
              <ParallaxText
                variant="h2"
                animationType="zoomIn"
                animationDuration={500}
              >
                {ReactHtmlParser(destinationSection?.ogamiDestinationHeading)}
              </ParallaxText>
            </Box>
            <Box className={cn.ogamiDestinationElement__data}>
              <ParallaxText
                variant="p"
                animationType="zoomIn"
                animationDuration={500}
              >
                {ReactHtmlParser(destinationSection?.ogamiDestinationContent)}
              </ParallaxText>
            </Box>
          </Box>
        </Box>
      </Box>
    </Stack>
  );
}
